module.exports = __webpack_public_path__ + "static/media/link-icon.f23408d3.svg";